module.exports = __webpack_public_path__ + "img/search.c6a0effb.svg";